import { useEffect } from 'react';
import { CustomerFormValidations } from './types.ts';
import { useFormContext } from 'react-hook-form';
import { CustomerSchema } from './CustomerFormProvider.tsx';

export function useApplyExternalValidations(
  validations?: CustomerFormValidations,
): void {
  const { setValue, trigger } = useFormContext<CustomerSchema>();

  useEffect(() => {
    setValue('externalValidations', {
      zipDoesNotExist: validations?.applicant?.zipDoesNotExist,
      coapplicantZipDoesNotExist: validations?.coapplicant?.zipDoesNotExist,
    });

    // The user must type in the input for this flag to go true->false, at which
    // point the regex based validation will take over. Therefore we can do this
    // check before calling `trigger` to avoid extra validations on component mount
    if (validations?.applicant?.zipDoesNotExist) {
      trigger('address.zip');
    }
    if (validations?.coapplicant?.zipDoesNotExist) {
      trigger('coapplicantAddress.zip');
    }
  }, [
    setValue,
    trigger,
    // since we only have 2 booleans we can save some triggers of this effect by
    // using them directly as deps instead of `validations`
    validations?.applicant?.zipDoesNotExist,
    validations?.coapplicant?.zipDoesNotExist,
  ]);
}
